import React, { useState, useRef, useEffect } from 'react';
import MainNav from '../Common/MainNav';
import EssentialsTemplate from '../Explore/Components/TempEssentialsTemplate';
import { MagnifyingGlassIcon } from '../../Constants/Icons';


const Orders = () => {


    const [orders, setOrders] = useState([]);
    const buttonLabels = [
        'In Progress',
        'Complete',
        'All Orders',
    ];

    const [selectedCategory, setSelectedCategory] = useState('All Orders');

    const handleCategoryClick = (button) => {
        setSelectedCategory(button);
        const filteredOrders = filterOrdersByCategory();
    };

    const [filteredOrders, setFilteredOrders] = useState([]);

    const updateFilteredOrders = () => {
        const filteredOrders = filterOrdersByCategory();
        setFilteredOrders(filteredOrders);
    };

    const filterOrdersByCategory = () => {
        if (selectedCategory === 'All Orders') {
            return orders;
        } else {
            return orders.filter(order => order.orderStatus === selectedCategory);
        }
    };

    useEffect(() => {
        updateFilteredOrders();
    }, [selectedCategory, orders]);


    const nameMapping = {
        "text_voice_notifications": "Text/Voice Notifications",
        "fax": "Fax",
        "scanner": "Scanner",
        "bluefin": "BlueFin Payment Gateway",
        "eclaims": "E-Claims",
        "rcm": "RCM",
        "fullscript": "FullScript",
        "wholescripts": "WholeScripts",
        "vitaminlab": "VitaminLab",
        "ecommerce": "E-Commerce",
        "charm_connect": "Charm Connect",
        "external_devices": "External Devices",
        "direct_message": "Direct Message",
        "quick_books": "Quick Books",
        "custom_branded_patient_app": "Custom Branded Patient App",
        "telehealth": "TeleHealth"
    };

    async function getAddOns() {
        try {
            let response = await fetch("https://ehr2.charmtracker.com/api/ehr/v1/addons/ehr", {
                headers: {
                    'Authorization': `Bearer ${sessionStorage.getItem('accessToken')}`,
                }
            });

            if (!response.ok) {
                throw new Error(`HTTP error! status: ${response.status}`);
            }

            let data = await response.json();
            sessionStorage.setItem('addons', JSON.stringify(data.data));
            return data;
        } catch (error) {
            console.error('Error fetching status:', error);
            return null;
        }
    }

    async function getPM() {
        try {
            let response = await fetch("https://ehr2.charmtracker.com/api/ehr/v1/addons/pm", {
                headers: {
                    'Authorization': `Bearer ${sessionStorage.getItem('accessToken')}`,
                }
            });

            if (!response.ok) {
                throw new Error(`HTTP error! status: ${response.status}`);
            }

            let data = await response.json();
            sessionStorage.setItem('pm', JSON.stringify(data.data));
            return data;
        } catch (error) {
            console.error('Error fetching status:', error);
            return null;
        }
    }

    const [fetchedPMData, setFetchedPMData] = useState([]);
    const [fetchedAddOnsData, setFetchedAddOnsData] = useState([]);
    const [categoriesExpanded, setCategoriesExpanded] = useState(false);

    useEffect(() => {
        const fetchData = async () => {

            if (!sessionStorage.getItem('addons')) {
                await getAddOns();
            }

            if (!sessionStorage.getItem('pm')) {
                await getPM();
            }
            const addons = JSON.parse(sessionStorage.getItem('addons'));
            const pm = JSON.parse(sessionStorage.getItem('pm'));


            setFetchedPMData(pm.data)
            setFetchedAddOnsData(addons.data)
        };

        fetchData();
    }, []);


    const capitalizeAndFormatName = (name) => {
        return name
            .split('_')
            .map(word => word.charAt(0).toUpperCase() + word.slice(1))
            .join(' ');
    };

    return (
        <div className="min-h-screen w-full flex flex-col bg-marketplaceBackground">
            <MainNav navbarColor={"#26051C"} />
            <div className="flex flex-row flex-grow">
                <div className="mx-8 mt-8 flex flex-col flex-grow">
                    <div className="flex flex-col">
                        <h3 className="text-2xl md:text-3xl font-bold border-b-2 border-exploreCategoriesBackground pb-2">Orders & Integrations</h3>

                        <div className="mt-8 flex flex-row justify-between items-center">
                            <div className="w-[30rem] p-4 bg-heroSearchbar h-12 rounded-full border-2 border-exploreSearchBorder flex flex-row items-center ">
                                <input
                                    type="text"
                                    className="w-full p-2 text-sm sm:text-lg h-10 focus:outline-none"
                                    placeholder="Search your orders"
                                />
                                <button className="m-2" >
                                    <MagnifyingGlassIcon />
                                </button>
                            </div>
                            <div className=" flex flex-row">
                                {buttonLabels.map((label, index) => (
                                    <button
                                        key={index}
                                        className={`text-${selectedCategory === label ? 'white' : 'black'} ${selectedCategory === label ? 'bg-exploreCategoriesBackground text-white' : 'bg-clear'} rounded-full font-semibold text-lg xl:text-xl font-semibold px-4 xl:px-5 py-2 xl:py-3 hover:bg-charmHover hover:text-integrationRequestTextHover`}
                                        onClick={() => handleCategoryClick(label)}
                                    >
                                        {label}
                                    </button>
                                ))}
                            </div>
                        </div>

                        <div className="mt-6">
                            <h4 className="text-lg md:text-xl 2xl:text-2xl font-bold border-exploreCategoriesBackground">Practice Management Tools</h4>
                            <div className={`mt-6 grid grid-cols-2  ${categoriesExpanded ? 'md:grid-cols-1' : 'md:grid-cols-3'}  ${categoriesExpanded ? 'lg:grid-cols-2' : 'lg:grid-cols-4'} ${categoriesExpanded ? 'xl:grid-cols-3' : 'xl:grid-cols-5'} 3xl:grid-cols-6 gap-4`}>
                                {Object.entries(fetchedPMData).map(([key, value]) => {
                                    return (
                                        <EssentialsTemplate
                                            key={key}
                                            name={capitalizeAndFormatName(key)}
                                            initialRequestStatus="Integrated"
                                        />
                                    );
                                })}

                                {/* {fetchedPMData.map((item, index) => (
                                    <EssentialsTemplate
                                        key={index}
                                        link={item && item.thumbnail ? item.thumbnail : undefined}
                                        description={item && item.essential_description ? item.essential_description : "No Description"}
                                        name={item && item.essential_name ? item.essential_name : "No Name"}
                                        initialRequestStatus="Integrated"
                                    />
                                ))} */}
                            </div>
                        </div>

                        <div className="mt-6 mb-12">
                            <h4 className="text-lg md:text-xl 2xl:text-2xl font-bold border-exploreCategoriesBackground">Other Essentials</h4>
                            <div className={`mt-6 grid grid-cols-2  ${categoriesExpanded ? 'md:grid-cols-1' : 'md:grid-cols-3'}  ${categoriesExpanded ? 'lg:grid-cols-2' : 'lg:grid-cols-4'} ${categoriesExpanded ? 'xl:grid-cols-3' : 'xl:grid-cols-5'} 3xl:grid-cols-6 gap-4`}>
                                {Object.entries(fetchedAddOnsData).map(([key, value]) => {
                                    return (
                                        <EssentialsTemplate
                                            key={key}
                                            name={capitalizeAndFormatName(key)}
                                            initialRequestStatus="Integrated"
                                        />
                                    );
                                })}
                            </div>
                        </div>

                    </div>
                </div>
            </div>
        </div >
    );
};

export default Orders;